import { apiClient } from './client'
import { DEFAULT_TOP_SELLERS_PERIOD, TOP_SELLERS_PERIODS } from '@/lib/dashboard'
import type { DashboardStats, TopSellersPeriod } from './types'

export interface DashboardStatsParams {
  topSellersPeriod?: TopSellersPeriod
}

function normalizeTopSellersPeriod(value: unknown, fallback: TopSellersPeriod): TopSellersPeriod {
  return TOP_SELLERS_PERIODS.find((period) => period === value) ?? fallback
}

function normalizeDashboardStats(data: unknown, requestedPeriod: TopSellersPeriod): DashboardStats {
  if (data && typeof data === 'object' && !Array.isArray(data)) {
    const result = data as Partial<DashboardStats>

    return {
      active_customers: typeof result.active_customers === 'number' ? result.active_customers : 0,
      daily_new_customers: Array.isArray(result.daily_new_customers) ? result.daily_new_customers : [],
      top_sellers: Array.isArray(result.top_sellers) ? result.top_sellers : [],
      top_sellers_period: normalizeTopSellersPeriod(result.top_sellers_period, requestedPeriod)
    }
  }

  return { active_customers: 0, daily_new_customers: [], top_sellers: [], top_sellers_period: requestedPeriod }
}

export async function getDashboardStats(params: DashboardStatsParams = {}): Promise<DashboardStats> {
  const topSellersPeriod = params.topSellersPeriod ?? DEFAULT_TOP_SELLERS_PERIOD

  const { data } = await apiClient.get<unknown>('/dashboard', { params: { top_sellers_period: topSellersPeriod } })

  return normalizeDashboardStats(data, topSellersPeriod)
}
